export const SIDEBAR_NAVIGATION_ROW_PADDING_X = 6;
export const SIDEBAR_NAVIGATION_ROW_RADIUS = 4;
export const SIDEBAR_NAVIGATION_ROW_ICON_SIZE = 20;
export const SIDEBAR_NAVIGATION_ROW_GAP = 12;
export const SIDEBAR_NAVIGATION_TREE_INDENT = 20;
